import { render, staticRenderFns } from "./AcoesRelatorios.vue?vue&type=template&id=b085c96a&scoped=true"
import script from "./AcoesRelatorios.vue?vue&type=script&lang=js"
export * from "./AcoesRelatorios.vue?vue&type=script&lang=js"
import style0 from "./AcoesRelatorios.vue?vue&type=style&index=0&id=b085c96a&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b085c96a",
  null
  
)

export default component.exports